/*
    geometryUtils provides a set of methods to do geometry calculation and modifications
    (c) starshiptroopers.dev
 */

export const geometryUtils = {
    // calculates polyline continuous and straight enough segments length (in points)
    calcSegmentsP: function (path) {
        let segments = [];

        let newSegment = function (x1, y1, x2, y2) {
            return {
                start: L.point(x1, y1),
                end: L.point(x2, y2),
                segments: [],
                length: Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2)),
                addSegment: function (segment) {
                    this.length += segment.length
                    this.end = segment.end
                    this.segments.push(segment)
                },
                bbox: function () {
                    return this.start.distanceTo(this.end)
                }
            }
        }
        try {
            let pathElements = path.getPathData();

            let pX, pY, length, pathElement, segment, i;
            let cX = 0
            let cY = 0
            for (i = 0; i < pathElements.length; i += 1) {
                pathElement = pathElements[i];
                pX = cX;
                pY = cY;
                cX = pathElement.values[0]
                cY = pathElement.values[1]
                if (pathElement.type === 'M') {
                    if (segment)
                        segments.push(segment)
                    segment = newSegment(cX, cY, cX, cY)
                    continue
                }
                if ( pathElement.type === 'L' ) {
                    let subSegment = newSegment(pX, pY, cX, cY)
                    //path starts from L element
                    if (!segment) {
                        segment = subSegment
                        continue
                    }
                    segment.addSegment(subSegment)
                    continue
                }

                if (pathElement.type === 'Z') {
                    if (segments.length > 0 && segment) {
                        let subSegment = newSegment(pX, pY, segments[0].start.x, segments[0].start.y)
                        segment.addSegment(subSegment)
                    }
                }
            }
            if (segment && segment.length > 0)
                segments.push(segment)
        } catch (e) {
            segments = [];
        }

        //debug
        if (path.id.includes("-134-58")) {
            console.log(`calcSegmentsP for feature ${path.id}`);
        }

        //check and fix double path
        //иногда линия может быть фактически кольцевой, путь доходит до конечной точки, а потом идёт обратно в начало по этим же точкам
        //такой баг был при экспорте карты высот
        //this fix is only works for continuous segments
        for (let i in segments) {
            let ss = segments[i].segments;
            let ssN = ss.length
            for (let j = ssN - 1; j >= 0 && j >= ssN - 1 - j; j-- ) {
                if ( (ss[j].end.equals(ss[ssN - 1 - j].start)) && (ss[j].start.equals(ss[ssN - 1 - j].end)) ){
                    let removedEl = ss.pop()
                    segments[i].length -= removedEl.length
                    segments[i].end = removedEl.start
                }
            }
        }

        return segments;
    },

    createTextNode: function (text, styleAttributes, path, minIndent) {
        if (text === "")
            return null

        let fontSize = (styleAttributes['font-size'] !== undefined) ? styleAttributes['font-size'] : 20;
        //let zoom = map.getZoom();

        //fix font size for large zoom levels (todo: need to refactor)
        //if (zoom > 20) {
        //    fontSize = fontSize + ( zoom * 0.2).toFixed(0) * 1;
        //}

        let lineWidth = path.getAttribute('stroke-width') * 1;
        let dy = (fontSize / 4).toFixed(0) * 1 + lineWidth;

        let textNode = L.SVG.create('text');
        let textPath = L.SVG.create('textPath');
        textPath.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", '#' + path.id);

        for (let attr in styleAttributes)
            textNode.setAttribute(attr, styleAttributes[attr]);

        textNode.setAttribute('font-size', fontSize + "px");

        textPath.appendChild(document.createTextNode(text));
        textNode.appendChild(textPath);

        // Define text X position
        // textNode should be added to svg in order to compute textLength, and because to simplify we just roughly compute a length using fontSize in pixels and string length
        //let textLength = textNode.getComputedTextLength()
        let textLength = text.toString().length * fontSize * 0.7;
        let segmentsP = geometryUtils.calcSegmentsP(path);
        let dx = geometryUtils.getBlockToPathInsertOffset(segmentsP, textLength, minIndent);
        //the text doesn't fit the segment
        if (dx === 0) {
            return null
        }

        textNode.setAttribute('dx', dx);
        textNode.setAttribute('dy', dy);

        //debug
        /*
        if (path.id.includes("-73-2674")) {
            console.log(segmentsP)
            console.log(`feature ${path.id} segments.length=${segmentsP[0].length}, dx=${dx}`)
        }
         */

        return textNode;
    },

    // getBlockToPathInsertOffset returns offset along the path where block with length blockLength can be placed
    getBlockToPathInsertOffset: function (segments, blockLength, minIndent) {
        let totalOffset = 0
        for (let i in segments) {
            let segmentOffset = this.blockInsertToCenterOffset(blockLength, segments[i].length, minIndent)
            if (segmentOffset > 0) {
                return totalOffset + segmentOffset
            } else {
                totalOffset += segments[i].length
            }
        }
        return 0
    },

    // returns the offset or 0 if the block doesn't fit the length
    blockInsertToCenterOffset: function (blockLength, totalLength, minIndent) {
        // Define text X position
        let offset = (totalLength / 2) - (blockLength / 2);
        //the text doesn't fit the segment
        if (offset - minIndent < 0)
            offset = 0

        return offset;
    },

    /**
     * returns array of layers that is covered with bounds region
     * @param bounds
     * @param layers
     * @returns {*[]}
     */
    layersCoveredWithBound: function (bounds, layers) {
        let coveredLayers = []
        for (let j in layers) {
            if (layers[j].getBounds) {
                let b = layers[j].getBounds()
                if (b != null && bounds.intersects(layers[j].getBounds())) {
                    coveredLayers.push(layers[j])
                }
            } else {
                if (bounds.contains(layers[j].getLatLng())) {
                    coveredLayers.push(layers[j])
                }
            }
        }
        return coveredLayers
    }
}
